import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType, DurationSchema } from '../base/baseSchema.js';

/**
 * This matches WorkflowSignals here: https://github.com/VivaaHealth/vivaa/blob/53e01c71782f369f284482e3ecedc1b3faf0dc41/backend/primary/src/clients/flow/types.ts#L1
 * Note: Primary includes APPOINTMENT_SCHEDULED, but that's not supported here, so it is omitted
 */
export enum FormCompletionWorkflowSignals {
  //  Purposely omitting: AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  FormSetCompleted = 'FORM_SET_COMPLETED',
  FormSetExpired = 'FORM_SET_EXPIRED',
  FormSetTerminal = 'FORM_SET_TERMINAL',
}

export const WaitForFormCompletionBlockConfigSchema = z.object({
  signalName: z.enum(FormCompletionWorkflowSignals),
  timeout: DurationSchema,
});
export type WaitForFormCompletionBlockConfig = z.infer<
  typeof WaitForFormCompletionBlockConfigSchema
>;

export const WaitForFormCompletionBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.WaitForFormCompletion),
  config: WaitForFormCompletionBlockConfigSchema,
});

export type WaitForFormCompletionBlock = z.infer<typeof WaitForFormCompletionBlockSchema>;
